import { CustomActionButtonAspect } from '@msdk/definitions'
import { COLORS, createComponentWrapperWithRef, css, MenuItem, styled, uiTokens } from '@msdk/ui'
import { MsdkStyledComponent } from '@msdk/ui/src/utils'

const MuiActionMenuItem: MsdkStyledComponent<any> = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'positionToDivider',
})`
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  color: ${COLORS.primary.main};
`
const getNovaActionMenuColor = (aspect?: CustomActionButtonAspect, disabled?: boolean) => {
  return aspect === CustomActionButtonAspect.Alternative && !disabled ? uiTokens.uiContent.error : undefined
}

const NovaActionMenuItem: MsdkStyledComponent<any> = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'positionToDivider',
})<{
  aspect?: CustomActionButtonAspect
  disabled?: boolean
}>`
  padding-left: 16px;
  padding-right: 16px;
  color: ${({ aspect, disabled }) => getNovaActionMenuColor(aspect, disabled)};

  svg {
    color: ${({ aspect, disabled }) => getNovaActionMenuColor(aspect, disabled)};
  }

  &:hover svg {
    color: ${({ aspect, disabled }) => getNovaActionMenuColor(aspect, disabled)};
  }
  & > p {
    color: ${({ aspect, disabled }) => getNovaActionMenuColor(aspect, disabled)};
  }
  &:hover {
    color: ${({ aspect, disabled }) => getNovaActionMenuColor(aspect, disabled)};
  }
  &:hover > p {
    color: ${uiTokens.uiContent.emphasized};
  }
`

export const ActionMenuItem = createComponentWrapperWithRef(
  {
    mui: MuiActionMenuItem,
    nova: NovaActionMenuItem,
  },
  'ActionMenuItem',
)

/* Item Text */

const commonActionMenuTextStyles = css`
  font-size: 16px;
  margin-left: 12px;
  line-height: 0px;
`

const MuiActionMenuText: MsdkStyledComponent<any> = styled('p')`
  ${commonActionMenuTextStyles}
  color: ${COLORS.text.primary};
`

const NovaActionMenuText: MsdkStyledComponent<any> = styled('p')<{
  aspect?: CustomActionButtonAspect
  disabled?: boolean
}>`
  ${commonActionMenuTextStyles}

  color: ${({ aspect, disabled }) =>
    aspect === CustomActionButtonAspect.Alternative && !disabled ? uiTokens.uiContent.error : undefined};
`

export const ActionMenuText = createComponentWrapperWithRef(
  {
    mui: MuiActionMenuText,
    nova: NovaActionMenuText,
  },
  'ActionMenuText',
)
